import Container from "Components/Container/Container";
import { useState, useEffect } from "react";

import Logo from "./Components/Logo/Logo";
import NavigationButton from "./Components/Navigation/NavigationButton";
import ContactWhatsapp from "./Components/Navigation/ContactWhatsapp";
import Drawer from "./Components/Navigation/Drawer";
import DrawerModalMobile from "./Components/Navigation/Drawer/DrawerModalMobile";

const Header = () => {
  const [drawerIsVisible, setDrawerIsVisible] = useState(false);

  const drawerVisibilityHandler = (value) => {
    if (typeof value === "object") {
      // Handle hover events
      if (value.type === "enter") {
        setDrawerIsVisible(true);
      } else if (value.type === "leave" && value.target === "drawer") {
        setDrawerIsVisible(false);
      }
    } else {
      // Handle click (for small screens)
      setDrawerIsVisible((prev) => !prev);
    }
  };

  const [isSticky, setIsSticky] = useState(false);
  const [scrollPosition, setScrollPosition] = useState(0);
  const [isDown, setIsDown] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollPos = window.scrollY;

      if (currentScrollPos === 0) {
        setIsSticky(false); // At the top, not sticky
        setIsDown(false);
      } else if (currentScrollPos < scrollPosition) {
        setIsSticky(true); // Scrolling up, make sticky
      } else {
        setIsSticky(false); // Scrolling down, not sticky
        setIsDown(true);
      }

      setScrollPosition(currentScrollPos);
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [scrollPosition]);

  return (
    <header
      className={`fixed w-full flex items-center z-[100] transition ease-in duration-300  ${
        isSticky
          ? "bg-black shadow shadow-[#333] translate-y-[0%] opacity-100 h-[7vh]"
          : "h-[10vh] opacity-100"
      } ${
        isDown ? "translate-y-[-100%] opacity-0" : "translate-y-[0%] opacity-0"
      }`}
    >
      <Container>
        <div
          className={`flex gap-x-10 items-center justify-between transition ease-in duration-300  ${
            isSticky ? "py-3" : " py-4"
          }`}
        >
          <Logo isDown={isDown} isSticky={isSticky} />
          <span
            className="flex items-stretch text-white relative"
            onMouseLeave={() =>
              drawerVisibilityHandler({ type: "leave", target: "drawer" })
            }
          >
            <NavigationButton
              isDown={isDown}
              isVisible={drawerIsVisible}
              isSticky={isSticky}
              onHandleDrawer={drawerVisibilityHandler}
            />
            <Drawer
              isDown={isDown}
              isSticky={isSticky}
              isVisible={drawerIsVisible}
              onHandleDrawer={drawerVisibilityHandler}
            />
            <DrawerModalMobile
              isDown={isDown}
              isSticky={isSticky}
              isVisible={drawerIsVisible}
              onHandleDrawer={drawerVisibilityHandler}
            />
          </span>
        </div>
      </Container>
    </header>
  );
};

export default Header;
